export default [
  {
    path: "/datalake/vulnerabilities-list",
    name: "VulnerabilitiesList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/VulnerabilitiesList.vue"),
    meta: {}
  },
  {
    path: "/datalake/exploitdb-list",
    name: "ExploitDBList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/ExploitDBList.vue"),
    meta: {}
  },
  {
    path: "/datalake/leak-account",
    name: "LeakAccountList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/leak/LeakAccountList.vue"),
    meta: {}
  },
  {
    path: "/datalake/misp-list",
    name: "MISPList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/MISPList.vue"),
    meta: {}
  },
  {
    path: "/datalake/reddit-list",
    name: "RedditList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/RedditList.vue"),
    meta: {}
  },
  {
    path: "/datalake/rss-sources-list",
    name: "RssSourcesList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/RssSourcesList.vue"),
    meta: {}
  },
  {
    path: "/datalake/channel-list",
    name: "ChannelList",
    component: () => import(
      /*webpackChunkName:'datalake'*/
      "@/views/datalake/ChannelList.vue"),
    meta: {}
  },
  {
    path: "/datalake/all-source",
    name: "DataLakeSourceList",
    component: () => import(
      /*webpackChunkName:'DataLakeSourceList'*/
      "@/views/datalake/DataLakeSourceList.vue"),
    meta: {}
  },
  {
    path: "/datalake/sensitive-findings",
    name: "SensitiveFindingsList",
    component: () => import(
      /*webpackChunkName:'SensitiveFindingsList'*/
      "@/views/datalake/SensitiveFindingsList.vue"),
    meta: {}
  },
]
